/*
 * @name: 
 * @Author: zxc
 * @Date: 2021-01-28 14:01:40
 * @LastEditors: zxc
 * @LastEditTime: 2021-08-31 15:54:29
 */
import { login, logout, getInfo } from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
// import state from '@/store'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    userInfo:{}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  setUserInfo: (state, data) => {
    state.userInfo = data
  }
}

const actions = {
  // 登陆
  login({ commit }, params) {
    // const { user, password } = params
    return new Promise((resolve, reject) => {
      login(params).then(response => {
        console.log('response', response)
        // const { data } = response
        commit('SET_TOKEN', response.headers.accesstoken)
        console.log('response', response)
        // setToken('userInfo', JSON.stringify(data))
        setToken(response.headers.accesstoken)
        // commit('setUserInfo', data);
        console.log(response)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setUser({ commit }, data){
    commit('setUserInfo', data);
  },
  // 退出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      removeToken(); // must remove  token  first
      removeToken('userInfo');
      // resetRouter();
      commit('RESET_STATE');
      resolve();
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js